const getCookie = function(name) {
  return (new RegExp('(?:^|; ?)' + name + '=([^;]*)').exec(document.cookie) || []).splice(1,1)[0];
};

const IS_PROD = (window.location.hostname === 'www.listmypractice.com' || window.location.hostname.indexOf('-preprod') > -1);

const API_ENDPOINT = function() { return IS_PROD ? '/api' : 'https://listmypractice-stage.klickcloud.net/api'; };

const IS_ED_MODE = (/[?&]ed=1/).test(window.location.search);

const DATA_ORIGIN_CODE = 'INDIVIOR_FATP_SITE';

const AUTHENTICATED_PAGES = [ '/listings', '/add-listing', '/edit-listing', '/request-confirmation' ];

const PENDING_STATUS_LIST = {
  'pendingadd': 'PENDING ADD',
  'pendingchange': 'PENDING UPDATE',
  'pendingdelete': 'PENDING DELETE',
}

const HCP_TYPE_LIST = {
  'MD': 'Medical Doctor',
  'NP': 'Nurse Practitioner',
  'PA': 'Physician Assistant',
  'DO': 'Doctor of Osteopathic Medicine',
}

const STATE_LIST = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'DC': 'District of Columbia',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'PR': 'Puerto Rico',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming',
}


module.exports = {
  IS_PROD,
  API_ENDPOINT,
  IS_ED_MODE,
  DATA_ORIGIN_CODE,
  AUTHENTICATED_PAGES,
  PENDING_STATUS_LIST,
  HCP_TYPE_LIST,
  STATE_LIST,
};